import * as React from "react";
import { useState, useContext } from "react";
import Button from "@mui/material/Button";
import { Box, Divider, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { appCtx } from "../../../utils/hooks/appContext";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../actions/snackbarActions";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import { useLocation } from "react-router-dom";
import { getDocument } from "../../../utils/services/projectService";

import {
  //GridRowModes,
  DataGrid,
  //GridToolbarContainer,
  //GridActionsCellItem,
} from "@mui/x-data-grid";

function ProjectItemDocumentation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // const params = useParams();
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const { setProjectId } = useContext(appCtx);
  const [loading, setLoading] = useState(true);
  //const [file, setFile] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    //Pozvati pravu metodu sa beka!!!!!!!!!!!!!!!!!!!
    /* getDocumentation()
      .then((response) => {
        console.log(response);
        setRows(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, "error", t("snackbar.fetchingDataError")));
      });*/

    getDocument(197).then((res) => {
      const link = document.createElement("a");
      let doc = new Blob();
      const linkDownload = "test";
      //console.log(res.data);
      //const streamStart = res.data.indexOf("stream") + 7;
      //const streamEnd = res.data.indexOf("endstream");
      //const pdfContent = res.data.slice(streamStart, streamEnd);
      //console.log(pdfContent);
      doc = new Blob([res.data], { type: "application/pdf" });
      link.download = `${linkDownload}.pdf`;
      console.log(doc);
      const url = URL.createObjectURL(doc);
      link.href = url;
      link.click();
      console.log(url);
    });

    setRows([
      { id: 1, docType: "Data sheet", link: "" },
      { id: 2, docType: "Drawing", link: "" },
      { id: 3, docType: "Control scheme", link: "" },
      { id: 4, docType: "Specification text", link: "" },
    ]);

    setLoading(false);
  }, []);
  const theme = useTheme();

  const RenderButtonOpen = (id) => {
    return (
      <Button
        onClick={(e) => {
          openPDF(id);
        }}
        // sx={{ color: theme.palette.secondary.main }}
      >
        <VisibilityIcon />
      </Button>
    );
  };

  const RenderButtonDownload = (id) => {
    return (
      <Button
        onClick={(e) => {
          downloadPDF(id);
        }}
        // sx={{ color: theme.palette.secondary.main }}
      >
        <DownloadIcon />
      </Button> //href='/project-item'
    );
  };

  const openPDF = (id) => {
    //const ID = rows.filter((row) => row.id === id ? ID : row.id);
    setProjectId(id.row.id);
    //localStorage.setItem("id", id.row.id);
    window.scrollTo(0, 0);
    navigate("/project-item", {
      state: {
        projectId: id.row.id,
        projectNumber: id.row.projectNumber,
        projectName: id.row.projectName,
      },
    });
  };

  const downloadPDF = (id) => {
    console.log("download");
  };

  const columns = [
    {
      field: "docType",
      headerName: t("documentation.type"),
      //width: 600,
      flex: 3,
    },
    {
      field: "path",
      headerName: t("documentation.path"),
      //width: 600,
      flex: 1,
      hide: true,
    },

    {
      field: "btnOpen",
      headerName: t("documentation.open"),
      //width: 100,
      cellClassName: "actions",
      renderCell: RenderButtonOpen,
      sortable: false,
      flex: 0.5,
    },

    {
      field: "btnDownload",
      headerName: t("documentation.download"),
      //width: 100,
      editable: true,
      cellClassName: "actions",
      renderCell: RenderButtonDownload,
      sortable: false,
      flex: 0.5,
    },
  ];

  //console.log(file);

  return loading ? (
    <Box sx={{ width: "100%", height: "75vh" }}>
      <Stack
        spacing={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
      </Stack>
    </Box>
  ) : (
    <>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <SnippetFolderIcon sx={{ width: 50, height: 50, m: 1 }} />
        <Typography component="h1" variant="h5" sx={{ margin: 2 }}>
          {t("documentation.title")} {}{" "}
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          minHeight: "70vh",
          width: "100%",
          "& .actions": {
            color: "text.secondary",
          },
          "& .textPrimary": {
            color: "text.primary",
          },
        }}
      >
        <Button>
          <FolderZipIcon />
          {t("documentation.downloadzip")}
        </Button>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            editMode="row"
            rowModesModel={rowModesModel}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </div>
      </Box>
    </>
  );
}

export default ProjectItemDocumentation;
